export default (
  data: any,
): { [key: string]: any } | null => {
  try {
    if (data) {
      if (typeof data === 'object') {
        return data;
      }
      return JSON.parse(data);
    }
    return null;
  } catch (error) {
    return null;
  }
};
